/* tslint:disable */

declare var Object: any;
export interface VerificationCodeInterface {
  "phone_number": string;
  "code": string;
  "id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt"?: Date;
}

export class VerificationCode implements VerificationCodeInterface {
  "phone_number": string;
  "code": string;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;
  constructor(data?: VerificationCodeInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `VerificationCode`.
   */
  public static getModelName() {
    return "VerificationCode";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of VerificationCode for dynamic purposes.
  **/
  public static factory(data: VerificationCodeInterface): VerificationCode{
    return new VerificationCode(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'VerificationCode',
      plural: 'VerificationCodes',
      path: 'VerificationCodes',
      idName: 'id',
      properties: {
        "phone_number": {
          name: 'phone_number',
          type: 'string'
        },
        "code": {
          name: 'code',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date',
          default: new Date(0)
        },
      },
      relations: {
      }
    }
  }
}
